import { Routes } from "@angular/router";
import { AccountComponent } from "src/app/account/account/account.component";
import { AccountchangepasswoerdComponent } from "src/app/account/accountchangepasswoerd/accountchangepasswoerd.component";
import { AccountsettingsComponent } from "src/app/account/accountsettings/accountsettings.component";
import { DocumentsComponent } from "src/app/account/documents/documents.component";
import { SupportComponent } from "src/app/account/support/support.component";
import { VouchersComponent } from "src/app/account/vouchers/vouchers.component";

export const USER_ROUTES: Routes = [
    {
        path: 'user/info', component: AccountComponent
    },
    {
        path: 'user/settings', component: AccountsettingsComponent
    },
    {
        path: 'user/changepassword', component: AccountchangepasswoerdComponent
    },
    {
        path: 'user/documents', component: DocumentsComponent
    },
    {
        path: 'user/support', component: SupportComponent
    },
    {
        path: 'user/vouchers', component: VouchersComponent
    }
]